<template>
  <div class="l-default-no-valid">
    <!-- ライフエール独自対応 ↓↓↓↓ -->
    <OrganismsCommonHeader v-if="isShowHeader" @clickMenuBtn="clickMenuBtn" />
    <!-- <Header :content="contentHeaderFooter" v-if="isShowHeader" /> -->
    <!-- ライフエール独自対応 ↑↑↑↑ -->
    <!-- ライフエールstay独自対応 -->
    <router-view class="font-setting"></router-view>
  </div>
</template>

<script>
import { get } from 'lodash'
// ライフエール独自対応 ↓↓↓↓ 
// import Header from '@/components/Header'
import OrganismsCommonHeader from "@crly/components/organisms/common/Header.vue";
// ライフエール独自対応 ↑↑↑↑

export default {
  name: 'DefaultLayout',
  components: {
    // ライフエール独自対応 ↓↓↓↓ 
    // Header,
    OrganismsCommonHeader
    // ライフエール独自対応 ↑↑↑↑
  },
  data() {
    return {
      scTimer: 0,
      scY: 0,
      headerNo: this.$route.meta.header,
      footerNo: this.$route.meta.footer,
      contentHeaderFooter: null,
      listShowHeader: ['/pages/no-valid-plan-menu']
    }
  },
  // ライフエール独自対応 ↑↑↑↑
  // created() {
  //   this.getData()
  // },
  // ライフエール独自対応 ↑↑↑↑
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    isShowHeader() {
      return this.listShowHeader?.includes(this.$route.path)
    }
  },
  methods: {
    handleScroll() {
      if (this.scTimer) return
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY
        clearTimeout(this.scTimer)
        this.scTimer = 0
      }, 100)
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    // ライフエール独自対応 ↓↓↓↓
    // getData() {
      // this.$repositories('cms')
      //   .getHeaderFooter()
      //   .then((response) => {
      //     this.contentHeaderFooter = get(response, 'data')
      //   })
    // },
    /**
     * メニューボタンクリックイベント
     * @param {boolean} status - スライドメニューの表示状態
     */
    clickMenuBtn(status) {
      this.$store.commit("menuStatus/setCategoryMenu", status);
      this.$store.commit("menuStatus/setSlideMenu", status);
    }
    // ライフエール独自対応 ↑↑↑↑
  },
  watch: {
    $route() {
      this.footerNo = this.$route.meta.footer
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
// ライフエールstay独自対応
.font-setting {
  font-family: "Noto Sans JP", sans-serif;
}
</style>
